export const CompassExercisesOverTimeLoading = () => {
  return (
    <div className="flex h-96 animate-pulse flex-col items-center rounded-2xl bg-gray-200">
      <div className="m-5 h-6 w-1/2 rounded-full bg-gray-300" />
      <div className="h-72 w-72 rounded-full bg-gray-300" />
    </div>
  );
};
